import { blue05, blue20opacity15, blue40 } from '../../../colors/blue';
import { gray20, gray35 } from '../../../colors/gray';
export var MuiTab = {
    styleOverrides: {
        root: {
            '&:hover': {
                boxShadow: "inset 0 -3px 0 ".concat(gray35),
            },
            '&[class*=Mui-selected]': {
                boxShadow: "inset 0 -3px 0 ".concat(blue40),
            },
            '&[class*=Mui-focusVisible]': {
                boxShadow: "0 0 0 2px ".concat(blue05),
            },
            '&[class*=MuiTab-overflow][class*=Mui-selected]': {
                backgroundColor: blue20opacity15,
            },
        },
        textColorSecondary: {
            '&[class*=Mui-selected]': {
                color: gray20,
            },
        },
    },
};
